import { render, staticRenderFns } from "./BedsCreateEdit.vue?vue&type=template&id=00e86e8a"
import script from "./BedsCreateEdit.vue?vue&type=script&lang=js"
export * from "./BedsCreateEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports